"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
var Login = (function (_super) {
    __extends(Login, _super);
    function Login(_a) {
        var _b = (_a === void 0 ? {} : _a).url, url = _b === void 0 ? '/sso/login/urls' : _b;
        var _this = _super.call(this) || this;
        _this.status = _this._defaultStatus;
        _this.fetchData(url);
        return _this;
    }
    Object.defineProperty(Login, "STORAGE_KEY", {
        get: function () {
            return 'heiseLogin-v2';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Login.prototype, "_defaultStatus", {
        get: function () {
            return __assign({
                session_id: null,
                user_id: null,
                user_hash: null,
                sso_logged_in: false,
                logged_in: false,
                urls: {
                    register: '/sso/registration',
                    profil: '/sso/registration/account/userdata',
                    logout: '/sso/login/logout',
                    sso: '/sso/login',
                },
            }, JSON.parse(window.localStorage.getItem(Login.STORAGE_KEY) || '{}'));
        },
        enumerable: true,
        configurable: true
    });
    Login.prototype.fetchData = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4, this._getJSON(url)];
                    case 1:
                        _a.status = (_b.sent());
                        window.localStorage.setItem(Login.STORAGE_KEY, JSON.stringify(this.status));
                        this.emit('login', this.status);
                        this.emit('loggedin', this.isLoggedIn());
                        return [3, 3];
                    case 2:
                        error_1 = _b.sent();
                        this.emit('error', error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Login.prototype._getJSON = function (url) {
        return new Promise(function (resolve, reject) {
            var xhr = new window.XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.onreadystatechange = function () {
                if (xhr.readyState === window.XMLHttpRequest.DONE) {
                    if (xhr.status !== 200) {
                        reject(xhr);
                        return;
                    }
                    resolve(JSON.parse(xhr.responseText));
                }
            };
            xhr.open('GET', url, true);
            xhr.send(null);
        });
    };
    Login.prototype.getURLs = function () {
        return this.status.urls;
    };
    Login.prototype.getStatus = function () {
        return this.status;
    };
    Login.prototype.isLoggedIn = function () {
        return this.status.sso_logged_in;
    };
    Login.prototype.getUserHash = function () {
        return this.status.user_hash;
    };
    return Login;
}(events_1.EventEmitter));
exports.default = Login;
